import { API_ENDPOINT } from "@/utils/misc";
import axios from "axios";

export const create = (payload) => {
  return axios.post(`${API_ENDPOINT()}/error-logs`, payload);
};
